var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report"},_vm._l((_vm.reports),function(item,index){return _c('div',{key:index,staticClass:"img-warpper"},[_c('img',{class:[item.isPad === '1' ? 'pad' : _vm.hasPad ? 'no-pad' : 'pad'],attrs:{"src":_vm.host + item.reportUrl}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }